import { useEffect, useState } from 'react';
import './CustomRange.less';
export default function CustomRange({ value, onChange, min, max, canNegative, iptw }) {
  const [currentValue, setCurrentValue] = useState(0);
  const [currentInput, setCurrentInput] = useState(0);
  useEffect(() => {
    setCurrentValue(value || 0);
    setCurrentInput(value || 0);
  }, [value]);
  const handleRangeChange = (val) => {
    setCurrentValue(val);
    setCurrentInput(val);
  };
  const handleChangeInput = (val) => {
    setCurrentInput(val);
  };

  const handleMouseUp = (val) => {
    if (val) {
      onChange(Number(val));
    } else {
      onChange(Number(currentValue));
    }
  };

  return (
    <div className="customRange_box">
      <div className="custom_range_box">
        <input
          type="range"
          min={min}
          value={currentValue}
          max={max}
          className="range custom_range"
          onChange={(e) => {
            handleRangeChange(e.target.value);
          }}
          onMouseUp={(e) => {
            handleMouseUp(e.target.value);
          }}
          onTouchEnd={(e) => {
            handleMouseUp(e.target.value);
          }}
          onKeyUp={(e) => {
            handleMouseUp(e.target.value);
          }}
        />
      </div>
      <input
        className="range_ipt"
        type="number"
        style={{ width: iptw ? iptw + 'px' : '' }}
        value={currentInput}
        onChange={(e) => {
          if (e.target.value === '') {
            handleChangeInput('');
            return;
          }
          let val = Number(e.target.value);
          if (val < min) val = min;
          if (val > max) val = max;
          handleChangeInput(val);
        }}
        onBlur={(e) => {
          if (e.target.value === '') {
            handleChangeInput(min);
            handleMouseUp('0');
          } else {
            handleRangeChange(e.target.value);
            handleMouseUp(e.target.value);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === '.' || e.key === (canNegative ? '' : '-') || e.key === 'e') {
            e.preventDefault();
          }
        }}
      />
    </div>
  );
}
